/* RESPONSIBLE TEAM: team-automation-foundations */
import Controller from '@ember/controller';

export default class AutomationFinAIAgentAskController extends Controller {
  queryParams = [];
}
